
import {connect} from '@viskan/deku-redux';
import {addItem as addArticle, addSubscription} from '../../../shopcart/actions';
import {close as closePopup} from '../../../popup-redux/actions';
import config from './config';
import Component from './components';

const getReduxArticle = state => ({
	active: state.article.active,
	addons: state.article.addons,
	article: state.article.article,
	articleIsLoaded: Boolean(state.article.article.art_id),
	isInStock: state.article.active.inStock,
	quantity: state.article.quantity
});

export const component = connect(
	(state, props) => ({
		popupIsOpen: state.popup.open,
		...(!props.itemId ? getReduxArticle(state) : {})
	}),
	{
		addArticle,
		addSubscription,
		closePopup
	}
)(Component);

export default {component, config};
